import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-25" }
const _hoisted_4 = { class: "position-relative table-src-form me-0" }
const _hoisted_5 = {
  class: "d-flex flex-wrap align-items-center",
  style: {"gap":"15px"}
}
const _hoisted_6 = { class: "dropdown select-dropdown" }
const _hoisted_7 = {
  class: "dropdown-toggle border text-body rounded-2 bg-transparent",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_8 = { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "default-table-area style-two pyx-19 recent-transactions3" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table align-middle" }
const _hoisted_13 = { class: "fw-medium" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap p-4",
  style: {"padding-top":"15px !important"}
}
const _hoisted_17 = { class: "fs-13" }
const _hoisted_18 = { "aria-label": "Page navigation example" }
const _hoisted_19 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  class: "modal fade",
  id: "transactionModal",
  tabindex: "-1",
  "aria-labelledby": "transactionModalLabel",
  "aria-hidden": "true"
}
const _hoisted_22 = {
  class: "modal-dialog modal-dialog-centered",
  style: {"max-width":"550px"}
}
const _hoisted_23 = { class: "modal-content rounded-0" }
const _hoisted_24 = { class: "modal-header border-0 p-4 border-bottom" }
const _hoisted_25 = {
  class: "modal-title fs-18",
  id: "transactionModalLabel"
}
const _hoisted_26 = { class: "modal-body p-4" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-lg-6" }
const _hoisted_29 = { class: "form-group mb-3" }
const _hoisted_30 = { class: "col-lg-6" }
const _hoisted_31 = { class: "form-group mb-3" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "col-lg-6" }
const _hoisted_34 = { class: "form-group mb-3" }
const _hoisted_35 = { class: "col-lg-6" }
const _hoisted_36 = { class: "form-group mb-3" }
const _hoisted_37 = { class: "col-lg-6" }
const _hoisted_38 = { class: "form-group mb-3" }
const _hoisted_39 = { class: "col-lg-6" }
const _hoisted_40 = { class: "form-group mb-3" }
const _hoisted_41 = { class: "col-lg-12" }
const _hoisted_42 = { class: "form-group mb-3" }
const _hoisted_43 = { class: "col-lg-12" }
const _hoisted_44 = { class: "d-flex justify-content-end flex-wrap gap-3" }
const _hoisted_45 = {
  type: "submit",
  class: "btn btn-primary py-2 px-4 fw-medium fs-16",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            class: "form-control border-0",
            placeholder: "Search here....",
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterTransactions && _ctx.filterTransactions(...args)))
          }, null, 544), [
            [_vModelText, _ctx.searchQuery]
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y text-secondary" }, " search ", -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary fw-medium rounded-3 hover-bg",
            "data-bs-toggle": "modal",
            "data-bs-target": "#transactionModal",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
          }, [...(_cache[16] || (_cache[16] = [
            _createElementVNode("span", {
              class: "d-flex align-items-center",
              style: {"gap":"5px"}
            }, [
              _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block fs-20 lh-1" }),
              _createElementVNode("span", null, "Add Transaction")
            ], -1)
          ]))]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.timeRange), 1),
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeRanges, (range) => {
                return (_openBlock(), _createElementBlock("li", { key: range }, [
                  _createElementVNode("button", {
                    class: "dropdown-item text-secondary py-2 px-3",
                    onClick: ($event: any) => (_ctx.filterByTimeRange(range))
                  }, _toDisplayString(range), 9, _hoisted_9)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Date"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Asset"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Type"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Amount"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Price"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Total Value"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Status"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Actions")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedTransactions, (transaction) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: transaction.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(transaction.date)), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(transaction.asset), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["d-inline-block rounded-1 fs-12 fw-medium", 
                      transaction.type === 'Buy'
                        ? 'bg-success-60 bg-opacity-25 text-success-60'
                        : 'bg-danger-80 bg-opacity-25 text-danger-80'
                    ]),
                      style: {"padding":"2px 8px"}
                    }, _toDisplayString(transaction.type), 3)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(transaction.amount) + " " + _toDisplayString(_ctx.getAssetSymbol(transaction.asset)), 1),
                  _createElementVNode("td", null, "$" + _toDisplayString(_ctx.formatPrice(transaction.price)), 1),
                  _createElementVNode("td", null, "$" + _toDisplayString(_ctx.formatPrice(transaction.totalValue)), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["d-inline-block rounded-1 fs-12 fw-medium", _ctx.getStatusClass(transaction.status)]),
                      style: {"padding":"2px 8px"}
                    }, _toDisplayString(transaction.status), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-outline-secondary me-2",
                      onClick: ($event: any) => (_ctx.editTransaction(transaction))
                    }, [...(_cache[17] || (_cache[17] = [
                      _createElementVNode("i", { class: "ri-edit-line" }, null, -1)
                    ]))], 8, _hoisted_14),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-outline-danger",
                      onClick: ($event: any) => (_ctx.confirmDelete(transaction.id))
                    }, [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("i", { class: "ri-delete-bin-line" }, null, -1)
                    ]))], 8, _hoisted_15)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, " Showing " + _toDisplayString(_ctx.showingFrom) + " to " + _toDisplayString(_ctx.showingTo) + " of " + _toDisplayString(_ctx.filteredTransactions.length) + " results ", 1),
          _createElementVNode("nav", _hoisted_18, [
            _createElementVNode("ul", _hoisted_19, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
              }, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Previous",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, [...(_cache[20] || (_cache[20] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))])
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "page-item",
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["page-link", { active: _ctx.currentPage === page }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_20)
                ]))
              }), 128)),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
              }, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Next",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))])
              ], 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("h1", _hoisted_25, _toDisplayString(_ctx.isEditing ? "Edit Transaction" : "Add New Transaction"), 1),
              _cache[22] || (_cache[22] = _createElementVNode("button", {
                type: "button",
                class: "btn-close campaigns-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("form", {
                onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", { class: "label text-secondary" }, "Date", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.date) = $event)),
                        class: "form-control h-60 border-border-color",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.formData.date]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _cache[24] || (_cache[24] = _createElementVNode("label", { class: "label text-secondary" }, "Asset", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.asset) = $event)),
                        class: "form-select form-control h-60 border-border-color",
                        required: ""
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assets, (asset) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: asset,
                            value: asset
                          }, _toDisplayString(asset), 9, _hoisted_32))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.formData.asset]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _cache[26] || (_cache[26] = _createElementVNode("label", { class: "label text-secondary" }, "Type", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.type) = $event)),
                        class: "form-select form-control",
                        required: ""
                      }, [...(_cache[25] || (_cache[25] = [
                        _createElementVNode("option", { value: "Buy" }, "Buy", -1),
                        _createElementVNode("option", { value: "Sell" }, "Sell", -1)
                      ]))], 512), [
                        [_vModelSelect, _ctx.formData.type]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _cache[27] || (_cache[27] = _createElementVNode("label", { class: "label text-secondary" }, "Amount", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.amount) = $event)),
                        class: "form-control h-60 border-border-color",
                        placeholder: "Enter Amount",
                        step: "0.000001",
                        required: "",
                        onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.calculateTotalValue && _ctx.calculateTotalValue(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.formData.amount]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _cache[28] || (_cache[28] = _createElementVNode("label", { class: "label text-secondary" }, "Price", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.price) = $event)),
                        class: "form-control h-60 border-border-color",
                        placeholder: "Enter Price",
                        step: "0.01",
                        required: "",
                        onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.calculateTotalValue && _ctx.calculateTotalValue(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.formData.price]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _cache[29] || (_cache[29] = _createElementVNode("label", { class: "label text-secondary" }, "Total Value", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.totalValue) = $event)),
                        class: "form-control h-60 border-border-color",
                        placeholder: "Enter Total Value",
                        step: "0.01",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, _ctx.formData.totalValue]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _cache[31] || (_cache[31] = _createElementVNode("label", { class: "label text-secondary" }, "Status", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.status) = $event)),
                        class: "form-select form-control",
                        required: ""
                      }, [...(_cache[30] || (_cache[30] = [
                        _createElementVNode("option", { value: "Done" }, "Done", -1),
                        _createElementVNode("option", { value: "Pending" }, "Pending", -1),
                        _createElementVNode("option", { value: "Failed" }, "Failed", -1)
                      ]))], 512), [
                        [_vModelSelect, _ctx.formData.status]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _cache[33] || (_cache[33] = _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger py-2 px-4 fw-medium fs-16 text-white",
                        "data-bs-dismiss": "modal"
                      }, " Cancel ", -1)),
                      _createElementVNode("button", _hoisted_45, [
                        _cache[32] || (_cache[32] = _createElementVNode("i", { class: "ri-add-line text-white fw-medium" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? "Update" : "Create"), 1)
                      ])
                    ])
                  ])
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ]))
}